/**
 * FormBuilderContext — shared context for AdvancedFormBuilder sub-components.
 * Provides all state and handlers so child panels can avoid deep prop-drilling.
 */
import { createContext, useContext } from 'react';

export const FormBuilderCtx = createContext(null);

/** Call inside any FormBuilder sub-component */
export function useFormBuilder() {
  const ctx = useContext(FormBuilderCtx);
  if (!ctx) throw new Error('useFormBuilder must be used inside <FormBuilderCtx.Provider>');
  return ctx;
}
